import React from 'react'
import { dashboard_url, protected_api_call } from '../api/api';
import { VscLoading } from "react-icons/vsc";
import { Link } from 'react-router-dom'


class EL extends React.Component {

    state = {
        list: [],
        title: ""
    }

    componentDidMount = async () => {
        this.setState({
            "loading": true
        })
        const currentUrl = window.location.href;
        const title = currentUrl.split("/").pop();
        let type="today"
        if(title === "scheduled_this_week") type="week"
        else if(title === "scheduled_next_week") type="nweek"
        let response = await protected_api_call(dashboard_url, {"type": type}, "POST");
        let data = await response.json();
        data = data["data"]
        this.setState({
            "list": data,
            "title": title
        })
    }

    render() {
        console.log(this.state)
        return (
            <div className='h-[60vh] flex-col ml-5'>
                <div className=' w-full flex justify-between'>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                        {this.state.title}
                    </h1>
                </div>

            {
                this.state.list.length == 0 ? (
                    <div className='grid mt-10 place-items-center'>
                        <h1 className='text-2xl font-bold border text-purple-800  border-purple-300 px-10 py-2 rounded-lg  bg-purple-200'>NO RESULTS FOUND</h1>
                    </div>
                ) : (
                    <>
                        {this.state.list.map((data, key) => (
                            <div className='flex justify-between items-center bg-purple-200 p-4 rounded-lg my-3 border border-purple-300 rounded-lg'>
                                <h1>Name: {data.FirstName + ' ' + data.LastName}</h1>
                                <h1>Hospital: {data.Hospital}</h1>
                                <h1>Diagnosis: {data.Diagonosis}</h1>
                                <h1>Criticality: {data.Criticality}</h1>
                                <h1>Insurance: {data.Insurance}</h1>
                                {/* <h1> Village: {data.NativeVillage === "" ? "NA" : data.NativeVillage} </h1> */}
                                <div>
                                    {/* <Link to={`/form/auth_${data.ApplicationID}`} state={{ "userinfo": data }} className='bg-green-600 mr-3 p-2 rounded-lg text-white text-center'>
                                        UPDATE
                                    </Link> */}
                                    <Link onClick={(event) => {}} target="_blank" rel="noopener noreferrer" to={`/info/${data.id}`} state={{"userinfo": data}} className='bg-purple-900 p-2 rounded-lg text-white text-center'>
                                        INFO
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </>       
                )
            }


            </div>
        )
    }



}


export default EL